import React, {useReducer, useState} from "react";
import {
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    FormGroup,
    FormControlLabel,
    Checkbox
} from "@mui/material";

import {LoadingButton} from "@mui/lab";
import Typography from "@mui/material/Typography";

const ConfirmationDialog = props => {
    const {options, onClose} = props;
    const [isLoading, setLoading] = useState(false);
    const [doNotAskMeLater, toggleDoNotAskMeLater] = useReducer((state) => !state, options.defaultDoNotAskMeLater);

    const handleClose = (object, reason) => {
        if (options && options.disableClose) {
            return;
        }

        if (isLoading) {
            return;
        }

        onClose();
    };

    const handleConfirm = async () => {
        setLoading(true);
        await options.onConfirm({doNotAskMeLater});
        setLoading(false);
        onClose();
    };

    return (
        <Dialog open={true}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth>

            <DialogTitle id="alert-dialog-title">
                {options.title}
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {options.description}
                </DialogContentText>
                {
                    options.showDoNotAskMeLater &&
                    <FormGroup>
                        <FormControlLabel control={<Checkbox checked={doNotAskMeLater} onChange={toggleDoNotAskMeLater} />}
                                          label={<Typography color="text.primary">{options.doNotAskMeLaterMessage}</Typography>}/>
                    </FormGroup>
                }
            </DialogContent>

            <DialogActions sx={{p: 2}}>
                {
                    options && !options.disableClose &&
                    <Button color="primary"
                            variant="outlined"
                            onClick={handleClose}>
                        {options.cancellationText}
                    </Button>
                }
                <Box sx={{m: 1}}>
                    <LoadingButton color="primary"
                                   variant="contained"
                                   onClick={handleConfirm}
                                   loading={isLoading}>
                        {options.confirmationText}
                    </LoadingButton>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export {ConfirmationDialog}